module.exports = __webpack_public_path__ + "templates.check-store-stock-modal-f019a70f.html";